export default [
  {
    title: "Вконтакте",
    name: "vk",
    color: "#4c75a3"
  },
  {
    title: "Facebook",
    name: "fb",
    color: "#3b5998"
  },
  {
    title: "Одноклассники",
    name: "ok",
    color: "#F59010"
  },
  {
    title: "Twitter",
    name: "tw",
    color: "#06cff1"
  },
  {
    title: "Telegram",
    name: "tg",
    color: "#31aadc"
  },
  {
    title: "СМИ",
    name: "gs",
    color: "#7c17e1"
  }
]
